/*
 * @Descripttion: 
 * @version: 
 * @Author: Sam
 * @Date: 2020-05-11 15:24:36
 * @LastEditors: mirror29
 * @LastEditTime: 2021-08-27 17:03:32
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/guide', // 先重定向到手动组卷，后面加上组卷首页后直接重定向到组卷首页
    },
    // { // 预留的组卷首页，分手动和智能两大模块
    //     path: '/paperFrontend',
    //     name: 'paperFrontend',
    //     component: () =>
    //         import ('@/views/paperFrontend'),
    // },
    {
      // 手动组卷
      path: '/paperFrontend/manual',
      name: 'manual',
      redirect: '/guide',
      component: () => import('@/views/manual'),
    },
    {
      // 试题搜索页面
      path: '/question/search',
      name: 'search',
      redirect: '/guide',
      component: () => import('@/views/search'),
    },
    {
      // 编辑组卷
      path: '/paperFrontend/paperEdit',
      name: 'paperEdit',
      redirect: '/guide',
      component: () => import('@/views/paperEdit'),
    },
    {
      // 分享页面
      path: '/paperFrontend/share',
      name: 'share',
      redirect: '/guide',
      component: () => import('@/views/share'),
    },
    {
      // 分享成功页面
      path: '/paperFrontend/shareSuccess',
      name: 'shareSuccess',
      redirect: '/guide',
      component: () => import('@/views/share_success'),
    },
    {
      // 错误页面
      path: '/guide',
      name: 'error',
      component: () => import('@/views/guide'),
    },
  ],
})
